import styled from 'styled-components';

export const DropdownList = styled.ul`
	box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
	display: block !important;
	list-style-type: none;
	margin-bottom: 10px;
	margin-top: 15px;
	padding: 0;
	position: absolute;
	right: 0;
	top: 50px;
	white-space: nowrap;
`;
